module.exports = __webpack_public_path__ + "img/menu_red_1.7b30f110.png";